import { Theme } from '@emotion/react'
import styled from '@emotion/styled'

type L1VSpaceProps = {
	spacing: number
} & { theme: Theme }

const L1VSpace = styled.div(({theme, spacing = 1}: L1VSpaceProps) => ({
	height: theme.spacing(spacing)
}))

export default L1VSpace
